// JavaScript z jQuery
$(document).ready(function() {
  var tabs = $(".WoocommerceTabs__single-tab");
  var panels = $(".WoocommerceTabs__panel");
  var bufferTop = -500; // Wysokość bufora od góry okna przeglądarki
  if(window.innerWidth >= 768) {
    function updateActiveTab() {
      // Oblicz odległość od górnej krawędzi okna przeglądarki do dolnej krawędzi widoku
      var windowBottom = $(window).scrollTop() + $(window).height();

      // Iteruj przez panele i znajdź aktywny panel
      panels.each(function(index) {
          var panelTop = $(this).offset().top;
          var panelHeight = $(this).height();
          // Oblicz odległość od dolnej krawędzi panelu do górnej krawędzi widoku
          var panelDistanceFromTop = panelTop - windowBottom;

          // Sprawdź, czy dolna krawędź panelu jest blisko górnej krawędzi widoku (z uwzględnieniem bufora)
          if (panelDistanceFromTop <= bufferTop && panelDistanceFromTop + panelHeight >= 0) {
              // Usuń klasę "in_view" ze wszystkich tabów
              tabs.removeClass("in_view");
              // Dodaj klasę "in_view" tylko do aktywnego tabu (o tym samym indeksie, co panel)
              tabs.eq(index).addClass("in_view");
          }
      });
  }

    // Aktualizuj aktywny tab na początku i przy każdym scrollu
    updateActiveTab();
    $(window).on("scroll", updateActiveTab);
    panels.each(function(index) {
    $(this).on("click", function(){
      updateActiveTab();
    })
    })
  }

});

